import React, { useEffect, useState } from "react";
import t from "../../../helpers/t";
import { moment } from "../../../../../vendor";
import Invoice from "./Invoice";

const Preview = (props) => {
  const {
    data,
    dispatch,
    setFilter,
    filter,
    sort,
    setSort,
    currentUrl,
    setNKey,
    _readFile,
    withActions,
    setWithActions,
    previewType = "invoice",
  } = props;
  setWithActions(false);
  return (
    <>
      <div
        id="inb-c-main-multiple-recipients"
        className="inb-c-listing off-canvas-content"
        data-off-canvas-content=""
      >
        {data === null ? (
          <>
            <div id="inb-app-collection-empty" className="inb-announcement">
              <div className="inb-image-box">
                <img src="assets/img/no_data.svg" />
              </div>
              <h3>{t("app_msg_collection_empty")}</h3>
              <p>{t("app_msg_collection_empty_body")}</p>
            </div>
          </>
        ) : (
          <>
            {data.map((invoice, index) => {
              if (typeof invoice.error !== "undefined") {
                return (
                  <>
                    <div className="inb-c-item inb-c-item--recipient row" key="none">
                      <div
                        className="medium-12 small-12 column"
                        title={t("none", null, "capital")}
                        style={{ minWidth: "90px" }}
                      >
                        <span style={{ textAlign: "left" }}>{invoice.error}</span>
                      </div>
                    </div>
                  </>
                );
              } else {
                // eslint-disable-next-line react/jsx-key
                return (
                  previewType === "invoice" && (
                    <>
                      <InvoiceSmall
                        invoice={invoice}
                        index={index}
                        dispatch={dispatch}
                        setFilter={setFilter}
                        filter={filter}
                        setNKey={setNKey}
                        sort={sort}
                        setSort={setSort}
                        currentUrl={currentUrl}
                        withActions={withActions}
                        _readFile={_readFile}
                      />
                    </>
                  )
                );
              }
            })}
          </>
        )}
      </div>
    </>
  );
};

export default Preview;
